export * from './card-details-compact.tsx'
